import { render, staticRenderFns } from "./widget-template-iframe.vue?vue&type=template&id=da3c7c98&scoped=true&"
import script from "./widget-template-iframe.vue?vue&type=script&lang=js&"
export * from "./widget-template-iframe.vue?vue&type=script&lang=js&"
import style0 from "./widget-template-iframe.vue?vue&type=style&index=0&id=da3c7c98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3c7c98",
  null
  
)

export default component.exports